<template>
  <!-- Banner Section -->
  <section class="banner-section banner-one" :class="{ 'is-loading': loading }">
    <div v-loading="loading" class="banner-loading-wrap">
      <div class="banner-carousel owl-theme owl-carousel" v-show="!loading && data.length">
        <div class="slide-item" v-for="(item, index) in data" :key="item.id || index">
          <img
            class="image-layer"
            :src="item.image"
            :alt="item.title"
            loading="lazy"
            @load="onBannerImageLoad(index)"
          />
          <div class="auto-container">
            <div class="content-box">
              <div class="content clearfix">
                <div class="inner">
                  <h2 class="title">{{ item.title }}</h2>
                  <div class="text">━━━━━━━</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 无数据占位，避免布局塌陷 -->
      <div v-show="!loading && !data.length" class="banner-placeholder">
        <span class="placeholder-text">暂无轮播内容</span>
      </div>
    </div>
  </section>
  <AboutUsText ref="aboutUsText" />
  <News ref="news" />
  <TendersCommon ref="tendersCommon" />
  <RecruitmentText ref="recruitmentText" />
  <ContactUsText ref="contactUsText" />
</template>

<script>
import api from '@/api/index.js'
import News from '@/views/publicComponent/newsText.vue'
import AboutUsText from '@/views/about/aboutUsText.vue'
import TendersCommon from '@/views/publicComponent/tendersCommon.vue'
import ContactUsText from '@/views/publicComponent/contactUsText.vue'
import RecruitmentText from '@/views/publicComponent/recruitmentText.vue'

const COLUMN_HOME = 'Home'
const COLUMN_ABOUT = 'About Us'
const COLUMN_NEWS = 'News'
const COLUMN_BIDDING = 'Bidding Information'
const COLUMN_RECRUITMENT = 'recruitment'
const COLUMN_CONTACT = 'Contact US'

export default {
  name: 'HomeIndex',
  components: { TendersCommon, AboutUsText, News, ContactUsText, RecruitmentText },
  data() {
    return {
      loading: true,
      data: [],
      carouselReady: false,
      URLTYPE: this.$store.screen.URLTYPE,
      Page: {
        total: 10,
        currentPage: 1,
        pageSize: 10,
        orders: [],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      this.carouselReady = false

      const tasks = [
        this.fetchBanner(),
        this.fetchAboutUs(),
        this.fetchNews(),
        this.fetchBidding(),
        this.fetchRecruitment(),
        this.fetchContact(),
      ]

      const results = await Promise.allSettled(tasks)

      results.forEach((result, index) => {
        const names = ['Banner', 'AboutUs', 'News', 'Bidding', 'Recruitment', 'Contact']
        if (result.status === 'rejected') {
          console.warn(`[Home] ${names[index]} 请求失败:`, result.reason)
        }
      })

      this.loading = false
      this.$nextTick(() => this.initCarousel())
    },

    fetchBanner() {
      return api
        .webList({
          pageNo: 1,
          pageSize: 10,
          isPublished: '1',
          columnName: COLUMN_HOME,
        })
        .then((res) => {
          if (res?.page?.list) {
            this.data = res.page.list
          }
        })
    },

    fetchAboutUs() {
      return api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1',
          columnName: COLUMN_ABOUT,
        })
        .then((res) => {
          const list = res?.page?.list
          if (list?.length && this.$refs.aboutUsText) {
            this.$refs.aboutUsText.init(list[0])
          }
        })
    },

    fetchNews() {
      return api
        .webList({
          pageNo: 1,
          pageSize: 5,
          isPublished: '1',
          columnName: COLUMN_NEWS,
        })
        .then((res) => {
          const list = res?.page?.list
          if (list?.length && this.$refs.news) {
            this.$refs.news.refreshList(list)
          }
        })
    },

    fetchBidding() {
      return api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1',
          columnName: COLUMN_BIDDING,
        })
        .then((res) => {
          if (res && this.$refs.tendersCommon) {
            this.$refs.tendersCommon.indexinit(res)
          }
        })
    },

    fetchRecruitment() {
      return api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1',
          columnName: COLUMN_RECRUITMENT,
        })
        .then((res) => {
          if (res && this.$refs.recruitmentText) {
            this.$refs.recruitmentText.refreshList(res)
          }
        })
    },

    fetchContact() {
      return api
        .webList({
          pageNo: this.Page.currentPage,
          pageSize: this.Page.pageSize,
          isPublished: '1',
          columnName: COLUMN_CONTACT,
        })
        .then((res) => {
          const list = res?.page?.list
          if (list?.length && this.$refs.contactUsText) {
            this.$refs.contactUsText.init(list[0])
          }
        })
    },

    onBannerImageLoad(index) {
      if (index === 0 && !this.carouselReady && this.data.length) {
        this.$nextTick(() => this.initCarousel())
      }
    },

    initCarousel() {
      if (this.carouselReady || !this.data.length) return
      if (typeof $ === 'undefined' || !$('.banner-carousel').length) return

      try {
        const $carousel = $('.banner-carousel')
        if ($carousel.data('owl.carousel')) {
          $carousel.trigger('destroy.owl.carousel')
          $carousel.removeClass('owl-loaded')
        }
        $carousel.owlCarousel({
          loop: true,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          margin: 0,
          nav: true,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 8000,
          autoplayHoverPause: true,
          navText: [
            '<span class="icon flaticon-arrows-1"></span>',
            '<span class="icon flaticon-right-arrow"></span>',
          ],
          responsive: {
            0: { items: 1 },
            600: { items: 1 },
            800: { items: 1 },
            1024: { items: 1 },
          },
        })
        this.carouselReady = true
      } catch (e) {
        console.warn('[Home] carousel init error:', e)
      }

      if ($('.news-carousel').length) {
        $('.news-carousel').owlCarousel({
          loop: false,
          margin: 30,
          nav: true,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 5000,
          navText: [
            '<span class="icon flaticon-back"></span>',
            '<span class="icon flaticon-next"></span>',
          ],
          responsive: {
            0: { items: 1 },
            600: { items: 1 },
            768: { items: 2 },
            1024: { items: 3 },
            1200: { items: 3 },
          },
        })
      }

      if ($('.testimonial-carousel').length) {
        $('.testimonial-carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: true,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 5000,
          navText: [
            '<span class="icon flaticon-back"></span>',
            '<span class="icon flaticon-next"></span>',
          ],
          responsive: {
            0: { items: 1 },
            600: { items: 1 },
            768: { items: 1 },
            1024: { items: 1 },
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.banner-section {
  position: relative;
  min-height: 760px;

  &.is-loading {
    min-height: 800px;
  }
}

.banner-loading-wrap {
  position: relative;
  min-height: inherit;
  border-radius: 0;

  :deep(.el-loading-mask) {
    background-color: rgba(0, 0, 0, 0.15);
  }
}

.banner-carousel {
  opacity: 0;
  animation: bannerFadeIn 0.4s ease-out forwards;
}

@keyframes bannerFadeIn {
  to {
    opacity: 1;
  }
}

.slide-item {
  .title {
    font-size: clamp(28px, 5vw, 55px);
    font-weight: 600;
    letter-spacing: 0.02em;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .image-layer {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.banner-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 760px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);

  .placeholder-text {
    color: #909399;
    font-size: 14px;
  }
}

.pattern-layer {
  background-image: url(/images/dongba/pattern-1.png);
  background-size: cover;
}
</style>
